import { motion } from "framer-motion";
import { Router, Camera, DoorClosed, SquareAsterisk, Siren, KeyRound } from "lucide-react";

const PRODUCTS = [
  { name: "Hub 2", cat: "Control Panel", desc: "The brain of the system — photo-verified alarms, cellular & Ethernet.", Icon: Router },
  { name: "MotionCam", cat: "Motion + Photo", desc: "Motion detector that snaps a photo the instant an alarm is triggered.", Icon: Camera },
  { name: "DoorProtect", cat: "Opening Detector", desc: "Instant alerts the moment a door or window is opened.", Icon: DoorClosed },
  { name: "KeyPad", cat: "Arm / Disarm", desc: "Sleek touch keypad to control your system by code.", Icon: SquareAsterisk },
  { name: "StreetSiren", cat: "Outdoor Siren", desc: "113 dB deterrent with LED indication for outdoor use.", Icon: Siren },
  { name: "SpaceControl", cat: "Key Fob", desc: "One-touch arming and a panic button in your pocket.", Icon: KeyRound },
];

const reveal = {
  hidden: { opacity: 0, y: 30 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1], delay: i * 0.06 },
  }),
};

export const AjaxProducts = () => {
  return (
    <section
      id="ajax-range"
      data-testid="ajax-products"
      className="relative border-t border-white/10 py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="mb-14 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-cyanbrand">
              / The Ajax range we install
            </span>
            <h2 className="mt-4 max-w-2xl font-display text-4xl md:text-6xl font-medium tracking-tight">
              Award-winning Ajax hardware,
              <br className="hidden md:block" /> fitted by us.
            </h2>
          </div>
          <p className="max-w-sm font-body text-sm text-white/50 leading-relaxed">
            As an Ajax Security Systems partner we design around the devices Europe
            trusts — wireless, verified and beautifully engineered.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {PRODUCTS.map((p, i) => (
            <motion.div
              key={p.name}
              variants={reveal}
              custom={i}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-50px" }}
              data-testid={`ajax-product-${p.name.toLowerCase().replace(/\s/g, "-")}`}
              className="group relative overflow-hidden border border-white/10 bg-[#0c0c0c] p-7 transition-colors duration-300 hover:border-cyanbrand/50"
            >
              <div className="pointer-events-none absolute -right-10 -top-10 h-32 w-32 rounded-full bg-cyanbrand/0 blur-2xl transition-colors duration-500 group-hover:bg-cyanbrand/10" />
              <div className="flex items-center justify-between">
                <span className="flex h-14 w-14 items-center justify-center border border-white/10 bg-black text-cyanbrand transition-colors duration-300 group-hover:border-cyanbrand/60">
                  <p.Icon className="h-6 w-6" strokeWidth={1.5} />
                </span>
                <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-white/40">
                  {p.cat}
                </span>
              </div>
              <h3 className="mt-6 font-display text-2xl font-medium tracking-tight">
                {p.name}
                <span className="ml-2 align-super font-mono text-[10px] text-cyanbrand">AJAX</span>
              </h3>
              <p className="mt-2 font-body text-sm text-white/55 leading-relaxed">{p.desc}</p>
            </motion.div>
          ))}
        </div>

        <p className="mt-8 font-mono text-[11px] uppercase tracking-wider text-white/30">
          Ajax™ and product names are trademarks of Ajax Systems. Installed by SC Security, an authorised partner.
        </p>
      </div>
    </section>
  );
};
